<script setup lang="ts">
import BaseDialog from "@/stories/dialogs/BaseDialog.vue";

type SizeTypes = "xs" | "sm" | "md" | "lg";

interface Props {
  size?: SizeTypes;
}

withDefaults(defineProps<Props>(), {
  size: "md",
});

defineEmits<{ close: [] }>();

const WIDTH_MAP: Record<SizeTypes, string> = {
  xs: "desktop:w-[30rem]",
  sm: "desktop:w-[31.25rem]",
  md: "desktop:w-[62.5rem]",
  lg: "desktop:w-[87.5rem]",
};
</script>

<template>
  <BaseDialog @on-close="$emit('close')">
    <div
      class="bg-white max-laptop:fixed max-laptop:top-0 max-laptop:left-0 overflow-hidden max-laptop:h-dvh laptop:max-h-[80dvh] flex flex-col justify-between w-full laptop:w-[832px]"
      :class="[WIDTH_MAP[size]]"
    >
      <slot></slot>
    </div>
  </BaseDialog>
</template>
